// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-button-element[data-v-6ecbcd50]{width:100%;height:100%;cursor:pointer;border:unset;transition:0.3s}.form-button-element[data-v-6ecbcd50]:hover{opacity:0.6}.form-button-element span[data-v-6ecbcd50]{font:inherit;width:100%;display:block}\n", ""]);
// Exports
module.exports = exports;
